import { FF_PHARMACIST_ORDERS_TABLE_SMALL_SIZE } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';

export function useOrdersPageSizeOptions() {
  const { flags } = useFeatureFlags();
  // The BE does not support batches bigger than 50 when running a legacy code variation.
  return [10, 25, 50, ...(flags[FF_PHARMACIST_ORDERS_TABLE_SMALL_SIZE] ? [] : [100])];
}
